/**
 * ADR-0013 — Sales Analytics: Top Products.
 * Aufrufer filtert Sales auf die gewünschte Period (gleiche Achse wie Revenue).
 */

import {
  getSaleLineActiveAmount,
  getSaleLineActiveQuantity
} from '../saleLineMath';

/**
 * @param {Array} sales
 * @param {{ limit?: number }} [options]
 * @returns {Array<{ productId: string, name: string, quantity: number, revenue: number }>}
 */
export function rankTopProducts(sales = [], { limit = 5 } = {}) {
  const productSales = {};

  for (const sale of sales || []) {
    if (!sale) continue;
    const items = sale.items || sale.products || sale.lineItems || [];

    if (items.length === 0 && sale.productId) {
      const productId = String(sale.productId);
      const itemQuantity = getSaleLineActiveQuantity(sale);
      const itemRevenue = getSaleLineActiveAmount(sale);
      if (!productSales[productId]) {
        productSales[productId] = {
          productId,
          quantity: 0,
          revenue: 0,
          name: sale.productName || sale.name || `Product ${productId}`
        };
      }
      productSales[productId].quantity += itemQuantity;
      productSales[productId].revenue += itemRevenue;
      continue;
    }

    for (const item of items) {
      if (!item?.productId) continue;
      const productId = String(item.productId);
      const itemQuantity = getSaleLineActiveQuantity(item);
      const itemRevenue = getSaleLineActiveAmount(item);
      if (!productSales[productId]) {
        productSales[productId] = {
          productId,
          quantity: 0,
          revenue: 0,
          name: item.name || item.productName || `Product ${productId}`
        };
      }
      productSales[productId].quantity += itemQuantity;
      productSales[productId].revenue += itemRevenue;
    }
  }

  return Object.values(productSales)
    .sort((a, b) => b.revenue - a.revenue)
    .slice(0, Math.max(0, limit));
}
